import { useEffect } from 'react';

import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import OutstandingLoanView from './outstandingLoanView/OutstandingLoanView';
import ApplyFlexiLoanInfoView from '../../applyFlexiLoanView/ApplyFlexiLoanInfoView/ApplyFlexiLoanInfoView';
import MainContentPending from '../../pageStructure/mainContentPending/index';
import * as selector from '../CBILSSelector';
import { ACTIVATE_SECOND_CBILS_DASHBOARD } from './SecondCBILSDashboard.actions';
import { useTrackPageView } from '../../../tracking/pageView';

const mapStateToProps = (state: RootState) => ({
    ready: state.CBILSDashboard.ready,
    hasOutstandingBalance:
        selector.getSecondCBILSAccountOutstandingTotal(state)! > 0
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    activate: () => dispatch({ type: ACTIVATE_SECOND_CBILS_DASHBOARD })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const SecondCBILSDashboard = ({
    hasOutstandingBalance,
    ready,
    activate
}: PropsFromRedux) => {
    useTrackPageView({ name: 'Second CBILS Dashboard' });

    useEffect(() => {
        activate();
    }, [activate]);

    if (!ready) {
        return <MainContentPending />;
    }

    if (hasOutstandingBalance) {
        return <OutstandingLoanView />;
    }

    return <ApplyFlexiLoanInfoView />;
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SecondCBILSDashboard);
